import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { VerificacionObraService } from 'src/app/datos/verificacion-obra.service';
import { HttpSession, Util } from 'src/app/libs/ruvpp-angular2-comun/index';
import { ServicioIndicadorCarga } from 'src/app/libs/ruvpp-angular2-comun/indicador-carga';
import { JsonResponse } from 'src/app/libs/ruvpp-angular2-comun/modelo/Index';
import { ServicioAlertas } from 'src/app/libs/ruvpp-angular2-comun/ServicioAlertas';
import { InputReporte, OutputReporteSiseviveEcocasa, OutputVistaInformacionGeneral, SeguridadSalida, SiseviveEcocasaDTO, ViviendaDTO } from 'src/app/modelo';

//@Autor: Ernesto López Hdez
@Component({
    selector: 'app-sisevive-ecocasa',
    templateUrl: './sisevive-ecocasa.component.html',
    //styleUrls: ['./sisevive-ecocasa.component.css']
})
export class SiseviveEcocasaComponent implements OnInit {

    public user: SeguridadSalida;
    public usuario: string;
    public verificador: string;

    //Forma

    public siseviveEcocasa: OutputReporteSiseviveEcocasa;
    public entity: ViviendaDTO;
    public vistaInformacionGeneral: OutputVistaInformacionGeneral;
    public btn_Disabled: boolean;

    /**
     * 
     * @param servicioIndicadorCarga
     * @param servicioAlertas
     * @param service
     * @param _router
     * @param spinner
     */
    constructor(private servicioIndicadorCarga: ServicioIndicadorCarga, private servicioAlertas: ServicioAlertas, private service: VerificacionObraService, private _router: Router, private spinner: NgxSpinnerService) {

        this.user = HttpSession.getAttribute('USER');

        if (this.user != null) {
            this.usuario = `${HttpSession.getAttribute('USER_NAME')}`;
            this.verificador = `${HttpSession.getAttribute('USER_VERIFICADOR')}`;
        }

        this.vistaInformacionGeneral = HttpSession.getAttribute('ENTITY');

        console.log('EcotecnologiasAtributosComponent -->> ', new Date());

    }

    /**
     * 
     */
    public async ngOnInit() {
        this.entity = <ViviendaDTO>{};
        this.siseviveEcocasa = <OutputReporteSiseviveEcocasa>{ listaViviendas: [] };
    }

    /**
     * 
     */
    public async init() {
        await this.loading();
    }

    /**
     * 
     */
    public async loading() {

        this.btn_Disabled = false;

        this.entity = <ViviendaDTO>{};

        this.siseviveEcocasa = <OutputReporteSiseviveEcocasa>{ listaViviendas: [] };

        let dato: InputReporte = <InputReporte>{ idOrdenVerificacion: this.vistaInformacionGeneral.ordenVerificacion };

        let resultado: JsonResponse<OutputReporteSiseviveEcocasa> = await this.service.ObtenerReporteSiseviveEcocasa(dato).toPromise();

        if (resultado != null && resultado.code == 200 && resultado.model != null) {

            this.siseviveEcocasa = resultado.model;

            if (this.siseviveEcocasa.listaViviendas != null && this.siseviveEcocasa.listaViviendas.length > 0) {

                this.entity = this.siseviveEcocasa.listaViviendas[0];

                //this.entity.claveEstatus = 0;

                await this.getListaSiseviveEcocasa(this.entity.idVVGeneral);
            }

            if ((this.siseviveEcocasa.listaViviendas != null && this.siseviveEcocasa.listaViviendas.length == 0) && (this.entity.listaSiseviveEcocasa != null && this.entity.listaSiseviveEcocasa == null)) {
                this.btn_Disabled = true;
            }

            //if (this.entity.listaSiseviveEcocasa != null && this.entity.listaSiseviveEcocasa.length > 0) {
            //    this.btn_Disabled = false;
            //}

        } else {
            console.error(`---------------------------------------------------------------------------------------------------------------------`);
            console.error(`Error: `, resultado);
        }
    }

    /**
     * 
     * @param idVVGeneral
     */
    private async getListaSiseviveEcocasa(idVVGeneral: number) {

        let dato: InputReporte = <InputReporte>{ idOrdenVerificacion: this.vistaInformacionGeneral.ordenVerificacion, idvvGeneral: idVVGeneral };

        Util.showLoadingMessage(this.spinner, `Obteniendo información ...`);

        let resultado: JsonResponse<OutputReporteSiseviveEcocasa> = await this.service.ObtenerReporteSiseviveEcocasa(dato).toPromise();

        Util.hideLoadingMessage();

        if (resultado != null && resultado.code == 200 && resultado.model != null) {

            this.entity.listaSiseviveEcocasa = resultado.model.listaSiseviveEcocasa;

            if (this.entity.listaSiseviveEcocasa != null) {
                for (let siseviveEcocasa of this.entity.listaSiseviveEcocasa) {
                    siseviveEcocasa.actualizado = false;
                }
            }

        } else {
            console.error(`---------------------------------------------------------------------------------------------------------------------`);
            console.error(`Error: `, resultado);
        }

    }

    /**
    * 
    * @param entity
    */
    public async onRowSelect(entity: ViviendaDTO) {

        this.entity = entity;

        if (this.entity.listaSiseviveEcocasa == null) {
            await this.getListaSiseviveEcocasa(entity.idVVGeneral);
        }

        //let object: ViviendaDTO = this.siseviveEcocasa.listaViviendas.filter(row => row.indentificadorVivienda == entity.indentificadorVivienda)[0];

    }

    /**
     * 
     * @param entity
     */
    public onRowUnselect(entity: any): void {

    }

    /**
   * 
   * @param entity
   */
    public onRowSelectEcotecnologia(entity: any): void {

    }

    /**
     * 
     * @param entity
     */
    public onRowUnselectEcotecnologia(entity: any): void {

    }

    /**
    * 
    */
    public Regresar(): void {
        Util.forward(this._router, 'VistaInformacionGeneralComponent');
    }

    /**
    * 
    */
    public async Guardar() {

        let listSiseviveEcocasaDTO: SiseviveEcocasaDTO[] = [];

        for (let viviendas of this.siseviveEcocasa.listaViviendas) {

            if (viviendas.listaSiseviveEcocasa != null) {

                let listSiseviveEcocasa: SiseviveEcocasaDTO[] = viviendas.listaSiseviveEcocasa.filter(row => row.actualizado == true);

                if (listSiseviveEcocasa != null && listSiseviveEcocasa.length > 0) {
                    listSiseviveEcocasaDTO.push(...listSiseviveEcocasa);
                }

            }

        }

        this.siseviveEcocasa.listaSiseviveEcocasa = listSiseviveEcocasaDTO;

        Util.showLoadingMessage(this.spinner, `Guardando información de reporte Sisevive - Ecocasa ...`);

        let resultado: JsonResponse<boolean> = await this.service.GuardarReporteSiseviveEcocasa(this.siseviveEcocasa).toPromise();

        Util.hideLoadingMessage();

        if (resultado != null && resultado.code == 200 && resultado.model != null) {

            let respuesta: boolean = resultado.model;

            if (respuesta == true) {

                var strCallback = (): void => {
                    this.Regresar();
                }

                let value = Util.showMessage(this.servicioAlertas, 'Verificación de Obra', 'Información guardada correctamente ...', 'success', false, strCallback);

            } else {
                Util.showMessage(this.servicioAlertas, 'Verificación de Obra', 'Error al intentar guardar la información ...', 'warning');
            }

        }
    }

    /**
     * 
     * @param entity
     * @param value
     */
    public onChangeCumplimiento(entity: SiseviveEcocasaDTO, value: number) {
        entity.cumple = value;
        entity.actualizado = true;
    }

    /**
     * 
     * @param entity
     */
    public getDisabledSiseviveEcocasa(entity: SiseviveEcocasaDTO): boolean {

        let resultado: boolean = false;

        if (this.entity.claveEstatus != 0) {
            resultado = true;
        }

        if (entity != null && entity.verRegistro == false) {
            resultado = true;
        }

        return resultado;
    }

}



